export default "__VITE_ASSET__0odl_kRb__"